/**
 * @ngdoc directive
 * @name donation
 *
 * @description
 * Page donation
 */
module.directive('donation', function () {
    'use strict';
    return {
        restrict: 'E',
        controller: ['$scope', function ($scope) {
            $scope.donationLink = {
                text: 'Faire un don',
                state: 'donation',
                label: 'Devenez acteur des Glénans, agissez !'
            };
        }],
        template:
                '<div class="aqua-donation">' +
                '  <div class="grid-main grid grid-center">' +
                '    <p class="grid grid-middle">' +
                '      <span class="aqua-donation--label grid-12-s">{{donationLink.label}}</span> ' +
                '      <button ui-sref="{{donationLink.state}}" class="aqua-donation--button grid-12-s">{{donationLink.text}}</button>' +
                '    </p>' +
                '  </div>' +
                '</div>'
    };
});